import React, { Component }from 'react';

import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import queryString from 'query-string';
import classnames from 'classnames';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import TestimonialWizard from './TestimonialWizard';
import Form from './Form';
import ContribsMap from './ContribsMap';
import ResumeFormButton from './ResumeFormButton';
import MenuDom, { BOUNDS } from './MenuDom';
import Success from './Success';
import ContribModal from './ContribModal';


export default class Screen5 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      popinDisplayed: true,
      contribModalDisplayed: false,
      currentContrib: {},
      mapBounds: BOUNDS.metropole,
      testimonialChoices: {},
      addResult: {},
    };
    this.topRef = React.createRef();
    this.targetElement = document.querySelector('#contrib-modal');
  }

  onPopupClose = () => {
    this.setState({popinDisplayed: false});
  }

  onContribModalOpen = (contrib) => {
    this.setState({
      currentContrib: contrib,
      contribModalDisplayed: true
    });
    disableBodyScroll(this.targetElement);
  }

  onContribModalClose = () => {
    this.setState({contribModalDisplayed: false});
    enableBodyScroll(this.targetElement);
  }

  onButtonClick = () => {
    this.setState({popinDisplayed: true});
  }

  onTestimonialWizardChange = (choices) => {
    this.setState({
      testimonialChoices: choices,
    });
    this.scrollToTop();
  }

  onWizardReset = () => {
    this.setState({
      testimonialChoices: {}
    });
  }

  setMapBounds = (bounds) => {
    this.setState({
      mapBounds: [...bounds]
    });
  }

  onAddSuccess = (data) => {
    this.setState({addResult: data});
  }

  scrollToTop = () => {
    this.topRef.current.scrollIntoView();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.scrollToTop();
    }
  }

  render() {
    const { location } = this.props;
    const qs = location ? queryString.parse(location.search) : ''
    const isStarted = this.state.testimonialChoices.testimonialChoice ? true : false;
    return (
      <div id="Screen_5">
        <div className="gp-content1" ref={this.topRef}>
          {(!isStarted && location.pathname !== '/') ? (
            <Redirect to="/"/>
          ): ''}
          <ResumeFormButton
            isWizardStarted={isStarted}
            onAct={this.onButtonClick}
            className={this.state.popinDisplayed ? "gp-hidden" : ""}
          />
          <MenuDom setMapBounds={this.setMapBounds}/>
          <div className={classnames("gp-content-1", this.state.popinDisplayed ? "": "gp-hidden")}>
            <TransitionGroup>
              {/*
                See: https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/examples/Animation/index.js
                no different than other usage of
              CSSTransition, just make sure to pass
              `location` to `Switch` so it can match
              the old location as it animates out
              */}
              <CSSTransition
                key={location.key}
                classNames="alert"
                timeout={300}
              >
                <Switch location={location}>
                  <Route path="/success">
                    <Success
                      onReset={this.onWizardReset}
                      onClose={this.onPopupClose}
                      addResult={this.state.addResult}
                    />
                  </Route>
                  <Route path="/add">
                    <Form
                      testimonialChoices={this.state.testimonialChoices}
                      onClose={this.onPopupClose}
                      qs={qs}
                      onAddSuccess={this.onAddSuccess}
                    />
                  </Route>
                  <Route path="/">
                    <TestimonialWizard
                      onChange={this.onTestimonialWizardChange}
                      onClose={this.onPopupClose}
                    />
                  </Route>
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>
        <div id="contrib-modal">
            <ContribModal
              isOpen={this.state.contribModalDisplayed}
              contrib={this.state.currentContrib}
              onClose={this.onContribModalClose}
            />
        </div>
        <ContribsMap
          bounds={this.state.mapBounds}
          onMoreDetails={this.contribModalDisplayed}
          onContribDetail={this.onContribModalOpen}
        />
      </div>
    );
  }
}
